import { render, staticRenderFns } from "./elEmailField.vue?vue&type=template&id=67c29446&"
import script from "./elEmailField.vue?vue&type=script&lang=js&"
export * from "./elEmailField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports